import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    border: `${theme.palette.cardBorder.main} solid 1px`,
    minHeight: theme.spacing(36.75),
    backgroundColor: theme.palette.text.white,
    position: 'relative',
  },
  dimensionsHeader: {
    backgroundColor: theme.palette.secondary.main,
    borderBottom: `${theme.palette.cardBorder.main} solid 1px`,
    padding: theme.spacing(2, 0, 2.125, 3),
  },
  formWidth: {
    width: '20%',
    minWidth: '135px',
  },
  textField: {
    marginLeft: theme.spacing(3),
    minWidth: '135px',
    width: '30%',
    '& .Mui-disabled': {
      color: theme.palette.labraText.primary,
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
  },
  heading: {
    color: theme.palette.text.primary,
    fontSize: '22px',
    textAlign: 'left',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  dimensionsBody: {
    padding: theme.spacing(3),
    minHeight: theme.spacing(22.75),
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  addDimensionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    width: 'fit-content',
    cursor: 'pointer',
  },
  addIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.opaque.dark,
    '&.MuiSvgIcon-root': {
      height: '20px',
      width: '20px',
    },
  },
  addText: {
    fontSize: '14px',
    color: theme.palette.opaque.dark,
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
    '& .Mui-disabled': {
      color: theme.palette.labraText.primary,
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
    },
  },
  iconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(0, 0, -3, 2.812),
  },
  divider: {
    height: '1px',
    color: theme.palette.cardBorder.main,
    marginTop: theme.spacing(4),
  },
  numberOfDaysField: {
    marginTop: theme.spacing(4),
    width: theme.spacing(26.375),
    textAlign: 'left',
    '& .MuiInputBase-input': {
      fontSize: '14px',
      fontWeight: 500,
      color: theme.palette.black.main,
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .Mui-disabled': {
      color: theme.palette.labraText.primary,
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
  },
  numberOfDaysContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  description: {
    marginLeft: theme.spacing(3),
    width: '30%',
    minWidth: '135px',
  },
  quantityFieldContainer: {
    display: 'flex',
    justifyContent: 'row',
    flex: 1,
    minWidth: '300px',
    width: '50%',
  },
  addDimensionsDisabled: {
    opacity: '0.3',
    cursor: 'default',
  },
  priceFieldsWidthAndSpacing: {
    marginRight: '10px',
  },
}))
